import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'field-value-widget',
  templateUrl: './field-value-widget.component.html',
  styleUrls: ['./field-value-widget.component.scss'],
})
export class FieldValueWidgetComponent {
  _value: string;
  @Input() set value(val: string){    
    this._value = (typeof val === 'string') ? val.replace('£', '').replace(/,/g, ''):val;     
    // PJT #14184 - removed   .replace(/,/g, '') : val; from above so that we do not get rid of commas
  }
  @Input() id: number;
  @Input() type: string;
  @Input() min: number;
  @Input() max: string;
  @Input() label: string;
  @Input() required: boolean;
  @Input() readonly: boolean;
  @Input() possibleValues: any;
  
  constructor() {}

  getYesNoText():string {        
    var v = this._value.toLocaleLowerCase().trim();
    if (v=='true' || v=="yes")
      return 'Yes';
    else if (v=='false'|| v=="no")
      return 'No';
    else
    return "-";
  }
}
